export const UPLOAD_TABLE_DATA = "boilerplate/ImsReco/Fetch/UPLOAD_TABLE_DATA";
export const UPLOAD_HISTORY_TABLE_DATA = "boilerplate/ImsReco/Fetch/UPLOAD_HISTORY_TABLE_DATA";
export const LOADER_STATUS = "boilerplate/ImsReco/Fetch/LOADER_STATUS";
export const SELECTED = "boilerplate/ImsReco/Fetch/SELECTED";
export const SELECTED_ROW = "boilerplate/ImsReco/Fetch/SELECTED_ROW";
export const TOTAL_PAGES_HISTORY = "boilerplate/ImsReco/Fetch/TOTAL_PAGES_HISTORY";
export const TOTAL_PAGES_UPLOAD = "boilerplate/ImsReco/Fetch/TOTAL_PAGES_UPLOAD";

export const headerColumns = [
  {
    value: "History",
    id: "1",
  },
  {
    value: "Upload History",
    id: "2",
  },
];